module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"firstYearCost":"First year cost"}}')
  delete Component.options._Ctor
}
